import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/workd/WORKD/PROJECT_2025/dashboard/core:template/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/workd/WORKD/PROJECT_2025/dashboard/core:template/layouts/default.vue").then(m => m.default || m))
}